"use strict";
/* eslint-disable */
// https://stackoverflow.com/a/2117523
Object.defineProperty(exports, "__esModule", { value: true });
function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
exports.default = uuid;
//# sourceMappingURL=uuid.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/uuid.js
// module id = IjXm
// module chunks = 20 21